export default "__VITE_ASSET__CUFD6Vye__"